import { KeyValueModel } from "model";
import { EnumTarja } from "model/enums/enum-tarja";

export const TarjaMedicamentoMock: KeyValueModel[] = [
    new KeyValueModel(EnumTarja.VendaLivre, "Venda Livre"),
    new KeyValueModel(EnumTarja.TarjaVermelha, "Tarja Vermelha"),
    new KeyValueModel(EnumTarja.TarjaPreta, "Tarja Preta"),
];